import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '../PendingsCard';
import PendingEventsContainer from './PendingEventsContainer';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import { getPendingEvents } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import PendingEventsEmptyState from './PendingEventsEmptyState';
import { AGENT } from '@/components/FilterBar/constants/filtersConstants';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';

function PendingEvents() {
  const dispatch = useDispatch();
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const track = useTrackPendingTab();
  const { countToday, loading, hasFetched, empty } = useSelector(
    (state) => state.DashboardSlice.events
  );
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  useFetchOnViewport(
    (query) => {
      dispatch(getPendingEvents(query));
    },
    [],
    { hasFetched }
  );

  let urlRedirect = `${tokkoHost}/schedule/full_calendar?time_mode=timeGridDay`;
  const onlyOneAgent =
    selectedIds.some((el) => el.filter_type === AGENT) &&
    selectedIds.length === 1;

  if (onlyOneAgent) {
    urlRedirect += `&agent=${selectedIds[0]}`;
  }
  if (selectedIds.length === 0) {
    urlRedirect += '&agent=all';
  }

  const eventText = `${countToday} ${Trans(
    translations,
    countToday === 1 ? 'EventForToday' : 'EventsForToday'
  )}`;

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={empty ? null : urlRedirect}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.pendingEvents(element)}
      >
        {eventText}
      </PendingCard.Header>
      {empty ? (
        <PendingEventsEmptyState />
      ) : (
        <PendingEventsContainer
          trackCallback={(element) => track.pendingEvents(element)}
        />
      )}
    </PendingCard>
  );
}

export default PendingEvents;
